import { generateGroupedDateLabels } from '../helpers';

const dateLabels = generateGroupedDateLabels();

const values = [22, 24, 36, 48, 50];

export const staffTransferredConversationsDummyData = {
  data: dateLabels.map((name, idx) => ({
    name,
    values: [{ key: 'staffTransfers', value: String(values[idx]) }],
  })),
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 180,
    totalAiThreads: 0,
  },
};
